import React from 'react';
import Axios from 'axios';
import { CSVLink, CSVDownload } from "react-csv";
import moment from 'moment';

const cstTableHeadersCSV = ['#', 'Date', 'Joueur', 'Operation', 'Ligue', 'Season', 'Débit', 'Crédit', 'Notes', 'Supprimée', 'Admin'];

class QvneaBooksOperationsCSV extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			csvTableData: [],
			dataReady: false
		};
		this.handleBackButton = this.handleBackButton.bind(this);
		
	}

	componentDidMount() {
		// console.log('MontQvnea: componentDidMount');
		this.loadCSVData();
	}

	loadCSVData() {
		var _this = this;
		Axios.get('/api/qvneaBooks/allOperationsDetailsCSV').then(function(responseAllOperations) {
			_this.buildCSVData(responseAllOperations.data);
		});
	}

	buildCSVData(allOperations) {
		var csvTableData = [];
		allOperations.forEach(function(oper, operIdx) {

			var csvTableDataRow = [];
			csvTableDataRow.push(oper.operIdx);
			csvTableDataRow.push(moment(oper.date).utc().format('YYYY-MM-DD'))
			csvTableDataRow.push(oper.fullname);
			csvTableDataRow.push(oper.type);
			csvTableDataRow.push(oper.leagueName);
			csvTableDataRow.push(oper.seasonName);
			csvTableDataRow.push(oper.debit);
			csvTableDataRow.push(oper.credit);
			csvTableDataRow.push(oper.notes);
			csvTableDataRow.push(oper.deleted.toString());
			csvTableDataRow.push(oper.user);

			// Build table
			csvTableData.push(csvTableDataRow.slice());
		});

		// CSV Data: copy tableData and add headers
		csvTableData.unshift(cstTableHeadersCSV);

		this.setState({
			csvTableData: csvTableData,
			dataReady: true
		});
	}

	render() {
		return (
			<div className="animated fadeIn">

      <div className="row">
      <div className="col-md-10 col-xs-12">
      	<h4>QVNEA Books - Sauvegarde des opérations</h4>
      	
      	{(this.state.dataReady) ?
      		<div>
		      	<p>Données prêtes !</p>
						<CSVLink
						  data={this.state.csvTableData}
						  filename={"qvnea-books-summary.csv"}
						  className="btn btn-sm btn-primary btn-margin-right-20"
						  target="_blank"> <i className="fa fa-download"></i> Télécharger le fichier .csv
						</CSVLink>
 						<button className="btn btn-sm btn-primary" onClick={this.handleBackButton}>	Retour aux QVNEA Books </button>
     		</div>
					:
	    		<div>
		      	<p>Données en téléchargement...</p>
						<button className="btn btn-sm btn-primary btn-margin-right-20" disabled>
							<i className="fa fa-download"></i> Télécharger le fichier .csv
						</button>
						<button className="btn btn-sm btn-primary" onClick={this.handleBackButton}>	Retour aux QVNEA Books </button>
	    		</div>
				}
			</div>
			</div>
			</div>
		)
	}

	handleBackButton(e) {
		const path = '/qvnea/qvnea-books';
		this.props.history.push(path);			
	}
}

export default QvneaBooksOperationsCSV;
